import { render, staticRenderFns } from "./CheckBoxColumn.vue?vue&type=template&id=0b89898f&scoped=true&"
import script from "./CheckBoxColumn.vue?vue&type=script&lang=js&"
export * from "./CheckBoxColumn.vue?vue&type=script&lang=js&"
import style0 from "./CheckBoxColumn.vue?vue&type=style&index=0&id=0b89898f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b89898f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b89898f')) {
      api.createRecord('0b89898f', component.options)
    } else {
      api.reload('0b89898f', component.options)
    }
    module.hot.accept("./CheckBoxColumn.vue?vue&type=template&id=0b89898f&scoped=true&", function () {
      api.rerender('0b89898f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/table/column/CheckBoxColumn.vue"
export default component.exports